// src/components/Nodes/ChooseProductsNode/ChooseProductsNode.js
import React from 'react';
import { Handle, Position } from 'reactflow';
import chooseProductsIcon from './chooseProductsIcon.svg';

const ChooseProductsNode = ({ data }) => {
  return (
    <div
      style={{
        padding: '10px',
        border: '5px solid #ddd',
        borderRadius: '25px',
        backgroundColor: '#fff',
        width: '105px',
        height: '105px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
      }}
    >
      <img
        src={chooseProductsIcon}
        alt="Choose Products"
        style={{ width: '50%', height: '50%' }}
      />
      <Handle
        type="target"
        position={Position.Left}
        style={{ borderRadius: 0 }}
      />
      <Handle
        type="source"
        position={Position.Right}
        style={{ borderRadius: 0 }}
      />
      <div
        style={{
          position: 'absolute',
          bottom: '-30px',
          width: '100%',
          textAlign: 'center',
          fontSize: '18px',
          whiteSpace: 'nowrap',
        }}
      >
        Choose Products
      </div>
    </div>
  );
};

export default ChooseProductsNode;
